import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  IzvestajiOPrometuPayload,
  MonitoringListFilterPayload,
  TrackingListFilterPayload,
} from "./trackAndTrace.types";

/**
 * Keys used to invalidate stored cached data regarding track & trace module
 */
export const trackAndTraceKeys = createQueryKeys("track_and_trace", {
  monitoringList: ({
    filters,
  }: {
    filters?: Partial<MonitoringListFilterPayload> | undefined;
  }) => ({
    queryKey: ["monitoring_list", filters],
  }),
  monitoringDetails: ({ id }: { id: number | null }) => ({
    queryKey: [id ?? undefined],
  }),
  trackingList: ({
    filters,
  }: {
    filters?: Partial<TrackingListFilterPayload> | undefined;
  }) => ({
    queryKey: [filters],
  }),
  trackingListFiltersData: () => ({
    queryKey: ["tracking_list_filters_data"],
  }),
  izvestajiOPrometu: ({
    filters,
  }: {
    filters?: Partial<IzvestajiOPrometuPayload> | undefined;
  }) => ({
    queryKey: ["izvestaji_o_prometu", filters],
  }),
});
